import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import AssetReport from "./AssetReport";
import { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";
import { saveAs } from "file-saver";
import GetAllBeaconDataRange from "../BeaconReportTable";
// import { getApp } from "firebase-admin/app";

const Report = () => {
  const storedUserRole = localStorage.getItem('userRole');

  const [timerange, setTimeRange] = useState("last_week");
  const [data, setSelectedData] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(()=>{
    const handleResize = ()=> setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return ()=> window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  const [formState, setFormState] = useState({
    userRoles: [],
  });
  const [loading, setLoading] = useState(false)

  const convertToCSV = (data) => {
    // Convert data to CSV format
    const csvRows = [];

    // Create headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));

    // Add rows
    for (const row of data) {
      const values = headers.map((header) => {
        const escaped = ("" + row[header]).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/report/assets`,
          {
            time_range: timerange,
          }
        );
        if (response.data.status == "success") {
          setSelectedData(response.data);
          setLoading(false)
        }
      }
      catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [timerange]);

  const [email, setgetEmails] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/v1/report/get/emails`
      );
      if (response.data.status == "success") {
        setgetEmails(response.data.emails);
      }
    };

    fetchData();
  }, []);

  let TimeRange = [
    {
      id: 1,
      value: "yesterday",
      name: "Yesterday",
    },
    {
      id: 2,
      value: "last_week",
      name: "Last Week",
    },
    {
      id: 3,
      value: "last_month",
      name: "Last Month",
    },
    {
      id: 4,
      value: "last_6_months",
      name: "Last 6 Month",
    },
    {
      id: 5,
      value: "all_time",
      name: "All Time",
    },
  ];

  const sendMail = async () => {
    let response;
    if (formState.userRoles.length == 0) {
      response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/report/assets/sendmail`,
        {
          time_range: timerange,
        }
      );
    } else {
      response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/report/assets/sendmail/gmail`,
        {
          recipient_emails: formState.userRoles.join(","),
          time_range: timerange,
        }
      );
    }

    if (response.data.status == "success") {
      window.alert(response.data.message);
    }
  };
  const handleExport = (format, tracked) => {
    // Format data according to the export format
    let formattedData;
    if (tracked == "untracked")
      formattedData = convertToCSV(data.untracked_assets);
    else formattedData = convertToCSV(data.tracked_assets);

    //  Convert data to Blob
    const blob = new Blob([formattedData], {
      type: "text/plain;charset=utf-8",
    });

    // // Save the Blob using FileSaver.js
    saveAs(blob, `${timerange}_${tracked}.${format}`);
  };
  const columns = [
    {
      field: 'id',
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "asset_name",
      headerName: "Asset Name",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Asset Name "}</strong>
      ),
      sortable: false,
      disableSelectionOnClick: true,
    },
    {
      field: "category_name",
      headerName: "category_name",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Category Name "}
        </strong>
      ),
    },
    {
      field: "gateway_device_id",
      headerName: "gateway_device_id",
      width: 180,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Gateway Device Id"}
        </strong>
      ),
    },
    {
      field: "gateway_id",
      headerName: "gateway_id",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Gateway Id "}</strong>
      ),
    },
    {
      field: "gateway_position",
      headerName: "gateway_position",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Gateway Position"}
        </strong>
      ),
    },
    {
      field: "location",
      headerName: "location",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Location"}</strong>
      ),
    },
    {
      field: "location_id",
      headerName: "location_id",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Location Id "}</strong>
      ),
    },
    {
      field: "mac",
      headerName: "mac",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Beacon Mac"}</strong>
      ),
    },
    {
      field: "rssi",
      headerName: "rssi",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"RSSI"}</strong>
      ),
    },
    {
      field: "ts",
      headerName: "gateway_id",
      width: 250,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Last Connected "}
        </strong>
      ),
    },
  ];

  const handleFieldChange = (event) => {
    setFormState((formState) => ({
      ...formState,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    }));
  };

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap : isMobile ?  "wrap" : "",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant={"h6"}
          style={{ color: "#07689f", fontSize: "24px", fontWeight: "bold" }}
          noWrap
        >
          <FormControl style={{ marginTop: "12px", marginBottom: isMobile ? "1.5rem" : ""}}>
            <InputLabel id="asset-select-label">Time Range</InputLabel>

            <Select
              labelId="asset-select-label"
              id="asset-select"
              name="Time Range"
              value={timerange}
              onChange={(e) => setTimeRange(e.target.value)}
              label="Time Range"
              style={{ width:isMobile ? 300: 165 }}
            >
              {TimeRange.map((time) => {
                return (
                  <MenuItem key={time.id} value={time.value}>
                    {time.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Typography>
        <Typography style={{ paddingRight: 32 }}>
          
          <TextField
            // classes={{ root: classes.root }}
            style={{ width:isMobile ? 300 : "15rem"  }}
            select
            disabled={storedUserRole == 'demo' ? true: false}
            name="userRoles"
            id="userRoles"
            variant="outlined"
            label="users"
            SelectProps={{
              multiple: true,
              value: formState.userRoles,
              onChange: handleFieldChange,
            }}
          >
            {email.map((each, index) => (
              <MenuItem id={index} value={each.email}>
                {each.email}
              </MenuItem>
            ))}
          </TextField>
          <Button
            onClick={storedUserRole == 'demo' ? () => '' :sendMail}
            variant="contained"
            style={{ marginLeft:isMobile ? "" : 12, marginTop: isMobile ? "1.5rem" : "", marginBottom:isMobile ? "1.5rem" : "" , backgroundColor: storedUserRole == 'demo' ? 'grey': ''}}

          >
            Send Email
          </Button>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography
          variant={"h6"}
          style={{ color: "#07689f", fontSize: "24px", fontWeight: "bold" }}
          noWrap
        >
          Tracked Asset: {data ? data.tracked_assets?.length : 0}
        </Typography>
        <DataGrid
          getRowId={(row) => row.asset_name}
          rows={data && data.tracked_assets ? data.tracked_assets : []}
          columns={columns}
          loading={loading}
          pageSize={10}
          rowSelection={false}
          rowsPerPageOptions={[10, 20, 30]}
          style={{ minHeight: 200}}
          density="compact"
          // components={{ Toolbar: GridToolbar }}
          components={{
            Toolbar: (props) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <GridToolbar {...props} />
                <Typography
                  onClick={() => handleExport("csv", "tracked")}
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    fontSize: "0.8125rem",
                    textTransform: "uppercase",
                    minWidth: "64px",
                    padding: "4px 5px",
                    fontWeight: 400,
                    color: "#1976d2",
                    cursor: "pointer",
                  }}
                >
                  Download as CSV
                </Typography>
              </div>
            ),
            FilterPanel: GridFilterPanel,
          }}
          slotProps={{
            filterPanel: {
              sx: {
                width: "100%",          // full width responsive
                maxWidth: "100%",
                padding: "10px",
                "& .MuiDataGrid-filterForm": {
                  flexDirection: "column",
                  gap: "10px",
                },
              },
            },
          }}
          componentsProps={{
            toolbar: {
              csvOptions: { disableToolbarButton: true },
              printOptions: { disableToolbarButton: true },
            },
          }}
          pagination
        />
      </Grid>
      <Grid item xs={12} style={{marginTop : isMobile ? "3.5rem" : ""}}>
        <Typography
          variant={"h6"}
          style={{ color: "#07689f", fontSize: "24px", fontWeight: "bold" }}
          noWrap
        >
          Untracked Asset : {data ? data.untracked_assets?.length : 0}
        </Typography>

        <DataGrid
          getRowId={(row) => row.asset_name}
          rows={data && data.untracked_assets ? data.untracked_assets : []}
          columns={columns}
          loading={loading}
          rowSelection={false}
          pageSize={10}
          style={{ minHeight: 200}}
          rowsPerPageOptions={[10, 20, 30]}
          density="compact"
          // components={{ Toolbar: GridToolbar }}
          components={{
            Toolbar: (props) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <GridToolbar {...props} />
                <Typography
                  onClick={() => handleExport("csv", "untracked")}
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    fontSize: "0.8125rem",
                    textTransform: "uppercase",
                    minWidth: "64px",
                    padding: "4px 5px",
                    fontWeight: 400,
                    color: "#1976d2",
                    cursor: "pointer",
                  }}
                >
                  Download as CSV
                </Typography>
              </div>
            ),
            FilterPanel: GridFilterPanel,
          }}
          componentsProps={{
            toolbar: {
              csvOptions: { disableToolbarButton: true },
              printOptions: { disableToolbarButton: true },
            },
          }}
          slotProps={{
            filterPanel: {
              sx: {
                width: "100%",          // full width responsive
                maxWidth: "100%",
                padding: "10px",
                "& .MuiDataGrid-filterForm": {
                  flexDirection: "column",
                  gap: "10px",
                },
              },
            },
          }}
          pagination
        />
      </Grid>
      <Grid item xs={12}>
      <Typography variant={"h6"} style={{ color: "#07689f", fontSize: '24px', fontWeight: 'bold', marginTop: 50 }} noWrap>
          Beacon Report
        </Typography>
        <GetAllBeaconDataRange/>
      </Grid>
      {/* <Grid item xs={12}>
        <Typography variant={"h6"} style={{ color: "#07689f", fontSize: '24px', fontWeight: 'bold' }} noWrap>
          Asset
        </Typography>
        <AssetReport />
      </Grid> */}
    </Grid>
  );
};

export default Report;

// import { Helmet } from "react-helmet";

// import { Box, Container, Grid, Pagination } from "@mui/material";
// // import { DashboardLayout } from "../components/dashboard-layout";
// import FiltersPanel from '../Report/filter-panel';

// import ReportTabs from "../Report/Report-Tabs";
// import { useState } from "react";


// const Page = () => 
// {
//   const [reportDataSupply, setReportDataSupply] = useState(null);
//   const [reportDataQuality, setReportDataQuality] = useState(null);
//   const [reportDataPump, setReportDataPump] = useState(null);

//   const handleReportDataSupply = (data) => {
//     setReportDataSupply(data);
//   };
//   const handleReportDataQuality = (data) => {
//     setReportDataQuality(data);
//   };
//   const handleReportDataPump = (data) => {
//     setReportDataPump(data);
//   };

//     return   (
//   <>
//    <Helmet>
//   <title>Reports | CoreData</title>
// </Helmet>
//     <Box
//       component="main"
//       sx={{
//         flexGrow: 1,
//       }}
//     >
//       <div >
//         <Container maxWidth={false}>
//         <Box p={3}>
//       <FiltersPanel onDataReceivedSupply={handleReportDataSupply} onDataReceivedQuality={handleReportDataQuality} onDataReceivedPump={handleReportDataPump}/>
//       <ReportTabs dataSupply={reportDataSupply} dataQuality={reportDataQuality} dataPump={reportDataPump}/>
//     </Box>
//       </Container>
//     </div>
//     </Box>
//   </>
// );

// }
  

// // Page.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

// export default Page;